<mat-form-field>
  <mat-label *ngIf="label"> {{ label | translate }} {{ isFieldRequired(ngControl.control) }}</mat-label>
  <mat-chip-grid #chipList [formControl]="ngControl.control" [disabledControl]="disabled">
    <mat-chip-row
      *ngFor="let item of value$ | async"
      [removable]="isChipRemovable"
      [attr.test-id]="item.name || item"
      (removed)="removeChip(ngControl.control, item)"
    >
      {{ item }}
      <ui-svg-icon *ngIf="isChipRemovable" [name]="iconNames.Close" [width]="18" matChipRemove></ui-svg-icon>
    </mat-chip-row>
    <input
      #chipsInput
      [formControl]="chipInputFormControl"
      [readonly]="isInputReadonly"
      [placeholder]="inputPlaceholder | translate"
      [matChipInputFor]="chipList"
      [matChipInputAddOnBlur]="isChipInputAddOnBlur"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [attr.test-id]="testId"
      [maxlength]="maxInputLength"
      (matChipInputTokenEnd)="addChip(ngControl.control, chipsInput, chipInputFormControl)"
    />
  </mat-chip-grid>
  <mat-hint *ngIf="hintText" class="info-text">{{ hintText | translate }}</mat-hint>
  <mat-error *ngIf="hasErrorMessageContainer">
    <ui-field-error-messages [control]="ngControl.control"></ui-field-error-messages>
  </mat-error>
</mat-form-field>
